import { API_URL, getCachedSessionId } from 'src/services/common';
import { api } from '../../../../util/axios-instance';

export const generatePassword = async (id) => {
  const response = await api.get(`${API_URL}/v1/project/${id}/user/generatePassword`, {
    headers: { 'x-session-id': getCachedSessionId() }
  });

  return response;
};
